import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { BadgesByCategory } from './badges-by-category.model';

export interface BadgesV2State extends EntityState<BadgesByCategory> { }

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'badges', idKey: 'storeId' })
export class BadgesV2Store extends EntityStore<BadgesV2State> {
    constructor() {
        super();
    }

    akitaPreAddEntity(entity: BadgesByCategory): BadgesByCategory & { storeId: number } {
        return {
            storeId: Math.floor(Math.random() * 1000000),
            ...entity
        }
    }
}
